'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Grid } from '@mui/material';
export default function GridList({ items = [], sx = {}, component: Component, spacing = 2, itemsPerRow = 4 }) {
    const sizing = 12 / itemsPerRow;
    return (_jsx(Grid, { container: true, spacing: spacing, children: items?.length > 0 &&
            items.map((item, index) => (_jsx(Grid, { item: true, xs: 12, md: sizing, children: _jsx(Component, { item: item, sx: sx.item, index: index }) }, index))) }));
}
